<template>
  <div>
   
      <ul class="cb-slideshow">
        <li>
          <span>Image 01</span>
        </li>
        <li>
          <span>Image 02</span>
        </li>
        <li>
          <span>Image 03</span>
        </li>
        <li>
          <span>Image 04</span>
        </li>
        <li>
          <span>Image 05</span>
        </li>
        <li>
          <span>Image 06</span>
        </li>
        <li>
          <span>Image 07</span>
        </li>
      </ul>

  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      safariAgent: false
    };
  },
  components: {},
  mounted() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") != -1) {
      if (ua.indexOf("chrome") > -1) {
        this.safariAgent = false;
      } else {
        this.safariAgent = true;
      }
    }
  }
};
</script>

<style>
.cb-slideshow,
.cb-slideshow:after {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 0;
}

.cb-slideshow li {
  list-style: none;
}

.cb-slideshow li span {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  color: transparent;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: none;
  opacity: 0;
  z-index: 0;
  animation: imageAnimation 36s linear infinite 0s;
}

.cb-slideshow li:nth-child(1) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/Bronzetailedplumeteer_Copearte.jpg");
}
.cb-slideshow li:nth-child(2) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/PDM-001_1.jpg");
  animation-delay: 5s;
}
.cb-slideshow li:nth-child(3) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/Keel billed toucan11_C7I5814.jpg");
  animation-delay: 10s;
}
.cb-slideshow li:nth-child(4) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/Chestnut headed oropendola2.jpg");
  animation-delay: 15s;
}
.cb-slideshow li:nth-child(5) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/Ijsvogel.jpg");
  animation-delay: 20s;
}
.cb-slideshow li:nth-child(6) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/jan-van-gent.jpg");
  animation-delay: 25s;
}
.cb-slideshow li:nth-child(7) span {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/Bronzetailedplumeteer_Copearte.jpg");
  animation-delay: 30s;
}

.anders {
  background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.6),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/background_images/PDM-001_1.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

@keyframes imageAnimation {
  0% {
    opacity: 0;
    animation-timing-function: ease-in;
  }
  4% {
    opacity: 1;
    animation-timing-function: ease-out;
  }
  21% {
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
</style>